import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DialogService } from '../../../../../core/services/dialog.service';
import { Round } from '../../../../../data/logic/math.functions';
import { TaxService, TaxTypeEnum } from '../../../../../data/logic/tax.service';
import { Job } from '../../../../../data/models';
import { SharedDataService } from '../../../../../data/services/shared-data.service';

export interface JobContractPriceModalResult {
    cancelled: boolean;
    total?: number;
    taxRate?: number;
    tax?: number;
    totalIncTax?: number;
    markup?: number;
    reason?: string;
}

@Component({
    selector: 'app-job-contract-price-modal',
    templateUrl: './job-contract-price-modal.component.html',
    standalone: false,
})
export class JobContractPriceModalComponent implements OnInit {
    // @ts-ignore TS2564
    @Input() job: Job;
    contractPrice = 0;
    contractMarkup = 0;
    taxCode = '';
    // @ts-ignore TS2564
    contractTaxRates: string;
    translated = {
        contractPrice: '',
    };
    reason = '';
    total = 0;
    taxRate = 0;
    tax = 0;
    totalIncTax = 0;
    action = new EventEmitter<JobContractPriceModalResult>();

    constructor(
        private bsModalRef: BsModalRef,
        private sharedData: SharedDataService,
        private taxService: TaxService,
        private translateService: TranslateService,
        private dialogService: DialogService
    ) {}

    ngOnInit(): void {
        this.contractPrice = this.job.ContractTotal;
        this.contractMarkup = this.job.ContractMarkup;
        this.taxCode = this.job.CalculationMethod === 0 ? this.sharedData.UserData.tenant.TaxCode : this.job.TaxRatesShortCode;
        this.contractTaxRates = this.taxService.resetItemTaxCodes(this.job.TaxRates, TaxTypeEnum.Income, 0);
        this.translated.contractPrice = this.translateService.instant('general.invoice.contract-price');
        this.setTotals();
    }

    setTotals() {
        this.total = Number(this.contractPrice);
        this.taxRate = this.job.TaxRate;
        if (this.job.CalculationMethod >= 1) {
            this.taxRate = this.taxService.findTaxRate(this.job.TaxRates, TaxTypeEnum.Income, this.contractTaxRates);
        }
        this.tax = Round(this.total * this.taxRate, 2);
        this.totalIncTax = this.total + this.tax;
    }

    // @ts-ignore TS7006
    taxRatesChanged(evt) {
        this.contractTaxRates = evt;
        this.setTotals();
    }

    ok() {
        if (this.job.PaymentTotal !== 0 && this.total < this.job.PaymentTotal) {
            const params = {
                text: `${this.translated.contractPrice} cannot be lower than amount invoiced already - $${this.job.PaymentTotal.toFixed(
                    2
                )}`,
                title: `${this.translated.contractPrice} can't be set`,
                showCancelButton: false,
            };
            this.dialogService.show(params);
            return;
        }

        this.action.emit({
            cancelled: false,
            total: this.total,
            taxRate: this.taxRate,
            tax: this.tax,
            totalIncTax: this.totalIncTax,
            markup: this.contractMarkup,
            reason: this.reason,
        });
        this.bsModalRef.hide();
    }

    cancel() {
        this.action.emit({ cancelled: true });
        this.bsModalRef.hide();
    }
}
